import React from "react";

import {ValidationRulesSearchStatus, Category} from "../types";

const CategoryDetailsCard = ({category: {cat_id, cat_num, last_update_date, manufacturer, prod_type, status}}: { category: Category }) => {
    return (
        <div className="category-details-card">
            <div className="cat-id-wrapper">
                <p className="cat-info-id">ID: {cat_id}</p>
            </div>
            <div className="cat-main-info-wrapper">
                <p className="cat-info-name">{cat_num} - {manufacturer} - {prod_type}</p>
                <p className="cat-info-status">{ValidationRulesSearchStatus[status]}</p>
            </div>
            <div className="cat-dates-info-wrapper">
                <p className="cat-date-info">Last update: {last_update_date}</p>
            </div>
        </div>
    );
};

export default CategoryDetailsCard;